import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const NoGapContentpoints =({data})=>{
    return(
        <>
        <div className="container-fluid p-0 m-0 bgeYantra">
        <Row className="p-0 m-0 align-items-center">
          
          <Col md={6} className="bgeYantra py-2 p-md-4 m-0 m-0">
            <h2 className="fs-48">{data.NogapHeading}</h2>
            <p>{data.Sectionparagraph}</p>
            <Row className="my-2 ">
              {data.Heading?.map((item, index)=>(
                 <Col md={12} className="mt-1">
                 <ul>
                   <li className="fs-24">
                       <b key={index}>{item.ListHeading} </b>
                     <br></br>
                    <span className="fs-16"> {item.ListParagraph}</span>
                   </li>
                 </ul>
               </Col>
              ))}
            </Row>
            <h3>{data.NogapSubheading}</h3>
            <Row className="align-items-baseline">
              {data.Categories?.map((item, index)=>(
                   <Col md={4} key={index} >
                   <img  src={item.ServiceImg} loading="lazy"
                    className="p-2 m-auto d-block"/>
                       <p className="px-2 text-center">
                           {item.ServiceText}
                       </p>
                   </Col>
              ))}
            </Row>
            <Link to="/contact-us">
            <Button id="btnCTA" className="fw-normal">Get a Quote</Button>
            </Link>
                
          </Col>

          <Col md={6} className="p-0 m-0">
            <img
              className="p-0 m-0 img-fluid" loading="lazy" 
              src={data.RightImgNogap}
              id="rightImgNogap"
            />
          </Col>
         
        </Row>
        
      </div>
        
        </>
    )
}

export default NoGapContentpoints;